import axios from '../utils/axios';

export function submitForm({ realName, mobilePhone, workUnitName, demand }) {
  const promise = axios.get(`https://lab.schoolearn.com/manage-api-1.0/EmailAPI/SendEmail?realName=${encodeURIComponent(realName)}&mobilePhone=${encodeURIComponent(mobilePhone)}&workUnitName=${encodeURIComponent(workUnitName)}&demand=${encodeURIComponent(demand)}`);
  return promise;
}